import { render, staticRenderFns } from "./FeedDash.vue?vue&type=template&id=066067e0"
import script from "./FeedDash.vue?vue&type=script&lang=ts"
export * from "./FeedDash.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports